module.exports = __webpack_public_path__ + "user-11e89860c52636e96f4f.svg";